<template>
  <section class="section">
    <div class="container">
      <form
        class="form has-placeholders"
        @submit.prevent="validateBeforeSubmit"
      >
        <fieldset>
          <h1 class="title">Request a Card</h1>

          <div class="-spacing-static-f">
            <label
              :class="{
                error: errors.has('car')
              }"
              >For which vehicle do you need a new card?</label
            >
          </div>

          <div
            v-for="vehicle in data.vehicles"
            :key="vehicle.id"
            class="field -spacing-static-c"
          >
            <label class="checkbox">
              <input
                class="checkbox__field"
                type="checkbox"
                name="car"
                :value="vehicle.id"
                v-validate="'required|included:1,2'"
              />
              <span class="checkbox__icon icon icon--check"></span>
              <span class="checkbox__label"
                >{{ vehicle.year }} {{ vehicle.model }}</span
              >
            </label>
          </div>

          <div class="-spacing-static-f">
            <label
              :class="{
                error: errors.has('delivery')
              }"
              >How would you like to receive your card?</label
            >
          </div>

          <div class="-spacing-static-c">
            <label
              :class="{
                checkbox: true
              }"
            >
              <input
                class="checkbox__field"
                type="checkbox"
                name="delivery"
                value="electronic"
                v-validate="'required|included:electronic,mail'"
              />
              <span class="checkbox__icon icon icon--check"></span>
              <span class="checkbox__label"
                >I would like an electronic copy <i class="icon-pdf"></i>
              </span>
            </label>
          </div>

          <div class="-spacing-static-c">
            <label
              :class="{
                checkbox: true
              }"
            >
              <input
                class="checkbox__field"
                type="checkbox"
                name="delivery"
                value="mail"
              />
              <span class="checkbox__icon icon icon--check"></span>
              <span class="checkbox__label"
                >Mail a card to my address on file</span
              >
            </label>
          </div>

          <button
            type="submit"
            class="button-primary  button-primary--black -spacing-static-f"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Submit</span>
          </button>
        </fieldset>
      </form>
    </div>
  </section>
</template>

<script>
const data = {
  vehicles: [
    {
      id: 1,
      model: 'Panamera 4 E-Hybrid Executive',
      year: 2018
    },
    {
      id: 2,
      model: '911 Carrera S Cabriolet',
      year: 2018
    }
  ]
};

export default {
  name: 'RequestACard',
  data: () => ({
    data,
    car: [],
    delivery: []
  }),
  methods: {
    validateBeforeSubmit() {
      let firstErrorField;

      this.$validator.validateAll().then(result => {
        if (result) {
          // this.$router.push({ path: '/' });
          alert('submitted!');
          return;
        }

        firstErrorField = this.$el.querySelector(
          '[name="' + this.$validator.errors.items[0].field + '"]'
        );
        firstErrorField.scrollIntoView(false);
        firstErrorField.focus();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  &__icon {
    transform: scale(0.7);
  }

  &__label {
    padding-left: 2rem;
  }
}
</style>
